import { $$ } from '../helpers/qsa'
import MicroModal from 'micromodal'

MicroModal.init({
    disableScroll: true,
    onClose: modal => {
        $$('form', modal).forEach(form => form.reset())
    }
})
